var Backbone = require('backbone'),
    _ = require('underscore'),
    moment = require('moment'),
    Util = require('../../FV/util'),
    fvChannel = require('glRadio').channel('FV');

module.exports = Backbone.Model.extend({

    defaults: {
        name: '',
        type: '',
        data: []
    },

    /*
    * Return the 'friendly' display value.
    * If a multi-value field, returns only the value of the first field.
    * */
    getShortenedDisplayValue: function() {

        var rawValue = this._getDisplayValue();

        return rawValue instanceof Array
            ? rawValue[0]
            : rawValue;

    },

    /*
    * Returns the 'friendly' display value of the field as one or more lines.
    * If a multi-value field, each value will be displayed on a separate line.
    * Used to print field values in the indexes module.
    * Could also be beneficial to print in HTML elements with correct CSS overflow settings for multivalue fields ...
    * eg, if display on one line with text-overflow ellipsis, could still only return the first value on one line
    * and use the title attribute to the entire value so the user could see it in the entirety.  A use case for this is
    * printing document names in the multi-doc nav select dropdown, though for now this is displaying 'document names', which is
    * now interpreted to mean only the first line.
    * */
    getMultiLineDisplayValue: function() {

        var rawValue = this._getDisplayValue();

        return rawValue instanceof Array
            ? rawValue.join('\n')
            : rawValue;
    },

    /*
    * Return either 'friendly' array of values (if multi value field) or just 'friendly' value as a string.
    * */
    _getDisplayValue: function() {

        var dataType = this.get('type'),
            initialValue = this.get('data'), // (this is an array)
            valueToOutput = '',
            s = fvChannel.request('settings');

        if (initialValue.length > 1) {

            // 'Multi-Value'

            if ( dataType === 'LIST_OF_DATE' ) {

                valueToOutput = _.map( initialValue, function(val) {
                    return moment(val).format(s.DATE_FMT_STR);
                });

            } else {

                // LIST OF STRING, LIST OF INTEGER
                valueToOutput = initialValue;
            }



        } else if ( initialValue.length > 0 ) {

            // Don't print formatted values if they don't exist
            // Note: decimal, small integer, & integer not formatted to mimic fat client.

            var firstValue = initialValue[0];

            switch(dataType) {

                case 'DATE':

                    // Note: non-valid iso -- see docs, as of v.2.9;
                    valueToOutput = moment(firstValue, s.DATE_FMT_STR).format(s.DATE_FMT_STR);
                    break;

                case 'DATE_TIME':
                    valueToOutput = moment(firstValue, s.DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR).format(s.DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR);
                    break;

                case 'MONEY':
                    valueToOutput = Util.formatNumber(firstValue);
                    break;

                default:
                    // STRING, INTEGER, BIG_INTEGER, SMALL_INTEGER, DECIMAL, SIGNATURE
                    valueToOutput = firstValue;
            }
        }

        return valueToOutput;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/index/model/indexModel.js
 ** module id = 402
 ** module chunks = 0
 **/